module.exports = __webpack_public_path__ + "img/img_sample3.8d45e35e.jpg";